require('./static/fonts.css');

const Modal = require('react-modal');
require('whatwg-fetch');

exports.onInitialClientRender = () => {
  Modal.setAppElement('#gatsby-focus-wrapper');
};
